export default {
  grade: {
    gradeCode: 'Mã Trình độ',
    gradeName: 'Tên Trình độ',
    createAt: 'Ngày tạo',
    status: 'Trạng thái'
  }
};
